import { getUniqueIdentifier } from '@com-delta-idp/mnx-skymiles-shared';
import { HttpHeadersPayload } from '@com-delta-idp/mnx-utils';

export const upgradesHeaderInfo: HttpHeadersPayload = {
  'Content-Type': 'application/json',
  transactionId: getUniqueIdentifier(),
  channelId: 'ZLYLOY',
  channelName: 'WEB'
};

export const commonHeaderInfo: HttpHeadersPayload = {
  'Content-Type': 'application/json',
  transactionId: getUniqueIdentifier()
};

export const COMMON_HEADER_KEY =
  '6558db7b2a24fd568d6853255cbba9606448bdb4797ae70c5ccd4535975dcc8b';

export const SKYCLUB_CUSTOM_HEADER_KEY =
  '39a3aa33e85daac1860b61b94a0df2f1a9334fb66bbbcdb99c2025e59d281d95';

export const enum TYPE {
  DELTA_360 = '360',
  MIN_LIMIT = '0',
  COMPLETE_LABEL = 'Complete',
  PENDING_EARNINGS = 'pending-earnings',
  QUALIFICATION_MILES = 'miles',
  QUALIFICATION_SEGMENTS = 'segments',
  QUALIFICATION_DOLLARS = 'dollars',
  QUALIFICATION_CARDS = 'cards',
  LOCALE = 'en-us',
  DIGITS_INFO = '1.0-0',
  OPTIONS_YEAR = 'numeric',
  OPTIONS_MONTH = 'short',
  OPTIONS_DEFAULT = 'default',
  NAME_PLACEHOLDER = '<NAME>',
  MONTH_PLACEHOLDER = '<Month>',
  YEAR_PLACEHOLDER = '<Year>',
  DATE_FORMAT = 'yyyy-MM-dd',
  X_PLACEHOLDER = '<X>',
  YEARS_LABEL = 'years',
  YEAR_LABEL = 'year',
  DEGREE = '°',
  REQUEST_TYPE = 'RETRIEVE_BYDOC_AND_COMBINE',
  APP = 'SKYMILES',
  CURRENCY_SYMBOL = '$',
  THOUSAND = 'k',
  TIME_ZONE = 'T12:00:00Z',
  MQD = 'MQDs',
  FUTURE = 'FUTURE',
  CURRENT = 'CURRENT',
  LIFETIME_MQM = 'LMQMs',
  AWARD_TRAVEL = 'award-travel',
  COMPLETE_PROFILE = 'complete-profile',
  EARNING_SIMPLER = 'earning-simpler',
  AVAIL = 'AVAIL',
  POSTED_ACTIVITY_COUNT = '${postedActivityCount}',
  MILLION_MILER = 'MM',
  DELTA_360_CODE = 'MV',
  TIER_CODE = 'MB',
  EDOCS_NO_DOCUMENT_CODE = 'PMT4170',
  NOT_APPLICABLE = 'N/A',
  DIAMOND_MEDALLION = 'DM',
  AIR_ACTIVITY_CODE = 'AA',
  ROLL = 'ROLL',
  ROLLOVER_MQM = 'Rollover MQMs',
  BEARER = 'Bearer',
  MEDALLION_STATUS = '[status]'
}

export const enum DefaultTooltip {
  background = '#FFF',
  color = '#0B1F66',
  position = 'bottom-right'
}

export const enum SkyClubMembership {
  SKY_CLUB_ID = 'skyClubMembershipCard',
  IS_SKY_CLUB_MEMBER = 'Y',
  BASE_MEMBER = 'FF',
  INDIVIDUAL_MEMBER = 'I',
  EXECUTIVE_MEMBER = 'E'
}

export const enum SkyClubTrackerConstant {
  UNLIMITED_MEMBERSHIP = 'UnlimitedMembership',
  UNLIMITED_EVER_GREEN = 'UnlimitedEvergreen',
  UNLIMITED_ACCESS = 'UnlimitedAccess',
  ZERO_VISITS = 'ZeroVisits',
  DEFAULT = 'Default',
  REMAIN = '[remainAmt]',
  DATE = '[date]',
  YEAR = '[year]',
  USD = '$',
  DATE_FORMAT = 'MMMM dd, yyyy',
  EN_US = 'en-US',
  CURRENT = 'Current',
  PREVIOUS = 'Previous'
}

export const enum ErrorConstant {
  EVENT_NAME = 'skymiles overview - {value} - error',
  TYPE = '{value} display error'
}

export const enum SECTION_NAME {
  VOUCHER_ECREDIT = 'voucher and ecredit',
  SKY_CLUB_TRACKER = 'sky club tracker',
  EARN_SUMMARY = 'earns summary',
  PERSONALIZATION = 'personalization',
  DASHBOARD = 'dashboard',
  TRACKER = 'skymiles tracker'
}

export const PLACE_HOLDER = '{value}';
